'use client';

import { Users, FileText, BarChart3 } from 'lucide-react';
import { PROJECT_NAME } from '@shared/constants';

/**
 * @group Employers
 * @summary Benefits section for employers page
 */
export function EmployerBenefitsSection() {
  const benefits = [
    {
      id: 'portal',
      icon: Users,
      title: 'Employee Portal Access',
      description: 'Simple, straightforward access for all employees. We provide onboarding support and educational materials. Employees can register, book consultations, and manage their health independently through our user-friendly platform.',
    },
    {
      id: 'sick-notes',
      icon: FileText,
      title: 'Sick Notes & Care Pathways',
      description: 'Employees receive official sick certificates when medically necessary, simplifying HR processes. Our care pathways ensure appropriate follow-up for chronic conditions or complex cases, with referrals to specialists when required.',
    },
    {
      id: 'analytics',
      icon: BarChart3,
      title: 'Usage Analytics',
      description: 'Employers receive aggregated, privacy-safe analytics showing utilisation patterns, common health concerns, and programme effectiveness. Individual employee health data remains completely confidential — you see trends, never personal medical information.',
    },
  ];

  return (
    <section className="py-20 bg-brand-mint">
      <div className="container mx-auto px-4 lg:px-8">
        <h2 className="text-3xl lg:text-4xl font-bold text-[#084349] text-center mb-12">
          What {PROJECT_NAME} Offers Employers
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {benefits.map((benefit) => {
            const Icon = benefit.icon;
            return (
              <div
                key={benefit.id}
                className="bg-card p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow"
              >
                <div className="w-16 h-16 bg-secondary rounded-xl flex items-center justify-center text-primary mb-6">
                  <Icon className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-semibold text-[#084349] mb-4">
                  {benefit.title}
                </h3>
                <p className="text-[#084349]/80 leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
